// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { Tabs as NextGenTabs } from '@teamnine/pcj-ui-v2'
import styled from 'styled-components'

export const Tabs = styled(NextGenTabs)`
  .nextgen-tabs-nav-wrap {
    border-bottom: 1px solid ${({ theme }) => theme.colors.nggray200};
  }
`
